import { render } from "./UploadTokoList.vue?vue&type=template&id=7587aea0&scoped=true"
import script from "./UploadTokoList.vue?vue&type=script&lang=js"
export * from "./UploadTokoList.vue?vue&type=script&lang=js"

import "./UploadTokoList.vue?vue&type=style&index=0&id=7587aea0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7587aea0"

export default script